import { render, staticRenderFns } from "./sportbook-sports.vue?vue&type=template&id=0e8aa132&scoped=true&"
import script from "./sportbook-sports.vue?vue&type=script&lang=js&"
export * from "./sportbook-sports.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-sports.vue?vue&type=style&index=0&id=0e8aa132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8aa132",
  null
  
)

export default component.exports